import { cva, type VariantProps } from 'class-variance-authority'

export const card = cva('rounded-2xl', {
    variants: {
        color: {
            blue: 'bg-primary-500 text-white',
            purple: 'bg-purple-500 text-white',
            orange: 'bg-yellow-800 text-yellow-100',
            green: 'bg-green-500 text-white',
            burgundy: 'bg-red-900 text-white',
            'light-blue': 'bg-primary-200 text-primary-500',
            'light-gray': 'bg-gray-100',
            white: 'bg-white text-gray-900',
        },
        size: {
            sm: 'px-1 py-2',
            md: 'px-3 py-4',
            lg: 'px-3 py-4'
        }
    },
    defaultVariants: {
        color: 'white',
        size: 'md',
    }
})

export type CardColor = VariantProps<typeof card>['color']